import { baseApi } from "./base";
import { customerQueries } from "./customer/customerQueries";
import { customerMutations } from "./customer/customerMutations";

const customerApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    ...customerQueries(builder),
    ...customerMutations(builder),
  }),
});

export const {
  useGetCustomersQuery,
  useGetCustomerByIdQuery,
  useCreateCustomerMutation,
  useUpdateCustomerMutation,
  useActivateCustomerMutation,
  useSuspendCustomerMutation,
  useGetCustomerServicesQuery,
  useGetCustomerBillingQuery,
} = customerApi;
